import { useRouterContext } from '@speedlo/hooks'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { Row } from 'reactstrap'
import styled from 'styled-components/macro'

import { ColStyle } from '../../common/ColStyle'
import { useOrderModel } from '../../hooks/useOrderModel'
import { usePortalNavigation } from '../../hooks/usePortalNavigation'
import ShopHeaderView from '../shop/ShopHeaderView'
import { OrderMethod } from './destination/OrderMethod'
import { usePickupMapQuery } from './hooks/usePickupMapQuery'
import { OrderMap } from './OrderMap'

const StyledMapView = styled.div`
  background-color: #e8e0d5;
  border-radius: 0.6rem;
  border: 1px solid #5a5a5a;
  min-height: 29rem;
  height: calc(100vh - 25rem);
  margin: 1.6rem 0 0 0;
  text-align: center;
  position: relative;

  .header {
    background-color: #5a5a5a;
    border-radius: 0.5rem 0.5rem 0 0;
    height: 3.75rem;
  }
`

export const MapView = observer(() => {
  const order = useOrderModel()
  const { history } = useRouterContext()

  // prefetch pickup branches
  usePickupMapQuery()
  usePortalNavigation()

  const onConfirm = React.useCallback(() => history.push(`/order`), [history])

  return (
    <>
      <ShopHeaderView />
      <Row className="justify-content-md-center">
        <ColStyle>
          <StyledMapView>
            <div className="header">
              <OrderMethod />
            </div>
            <OrderMap
              onConfirm={onConfirm}
              orderMethod={order.orderMethodEnum}
            />
          </StyledMapView>
        </ColStyle>
      </Row>
    </>
  )
})

export default MapView
